import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";
import { clientRoute } from "../constants/routes";

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-primary">
        <Loader2 className="h-8 w-8 animate-spin text-indigo-600" />
      </div>
    );
  }

  if (user) {
    // Redirect to the page they were trying to go to or dashboard
    const from = location.state?.from?.pathname || clientRoute("/home");
    return <Navigate to={from} replace />;
  }

  return children;
};

export default PublicRoute;